import React from "react";
import {Box} from "@mui/system";
import {DialogContent, Typography} from "@mui/material";
import {
    formatModuleCompositionPanelSizeDialogCurrent,
    getModuleCompositionDisplayName,
} from "../../utils/compositionMediaUtils";

const catalogModuleChangeDialogListSx = {
    m: 0,
    pl: "20px",
};

const catalogModuleChangeDialogListItemSx = {
    fontSize: "14px",
    lineHeight: 1.4,
    color: (theme) => theme.palette.text.main,
};

const catalogModuleChangeDialogEmphasisSx = {
    fontWeight: 600,
};

export function CompositionModuleChangeConfirmDialogContent({
    primaryRow,
    dependentRows = [],
    dimensionLabel,
    previousValue,
    nextValue,
}) {
    if (!primaryRow) {
        return null;
    }

    const moduleName = getModuleCompositionDisplayName(primaryRow);
    const displayPrevious = previousValue ?? "—";
    const displayNext = nextValue ?? "—";
    const hasDependents = dependentRows.length > 0;

    return (
        <DialogContent sx={{pt: 0, pb: 2, px: "1.25rem"}}>
            <Typography sx={{mb: 1.5, fontSize: "16px", lineHeight: 1.5}}>
                Вы собираетесь изменить{" "}
                <Box component="span" sx={catalogModuleChangeDialogEmphasisSx}>
                    {dimensionLabel}
                </Box>{" "}
                модуля{" "}
                <Box component="span" sx={catalogModuleChangeDialogEmphasisSx}>
                    «{moduleName}»
                </Box>{" "}
                с{" "}
                <Box component="span" sx={catalogModuleChangeDialogEmphasisSx}>
                    {displayPrevious}
                </Box>{" "}
                на{" "}
                <Box component="span" sx={catalogModuleChangeDialogEmphasisSx}>
                    {displayNext}
                </Box>
                .
            </Typography>
            {hasDependents ? (
                <>
                    <Typography sx={{mb: 0.75, fontSize: "14px", lineHeight: 1.5}}>
                        В этом случае также изменятся размеры связанных с ним модулей:
                    </Typography>
                    <Box component="ul" sx={catalogModuleChangeDialogListSx}>
                        {dependentRows.map((row) => (
                            <Typography
                                component="li"
                                key={row.id}
                                sx={catalogModuleChangeDialogListItemSx}
                            >
                                {getModuleCompositionDisplayName(row)}
                                {" "}
                                <Box
                                    component="span"
                                    sx={{color: (theme) => theme.palette.text.secondary}}
                                >
                                    ({formatModuleCompositionPanelSizeDialogCurrent(row)})
                                </Box>
                            </Typography>
                        ))}
                    </Box>
                </>
            ) : null}
            <Typography
                sx={{
                    mt: 1.5,
                    fontSize: "14px",
                    fontWeight: 700,
                    lineHeight: 1.5,
                    color: (theme) => theme.palette.text.main,
                }}
            >
                {hasDependents
                    ? "Кроме того, изменится текущая цена."
                    : "При этом изменится текущая цена."}
            </Typography>
        </DialogContent>
    );
}
